import { useLayoutEffect, useState } from 'react';

/** Standalone catalogue pages reserve their dashboard's bottom padding. */
export function useViewportHeight(bottomGap = 32) {
  const [element, ref] = useState<HTMLDivElement | null>(null);
  const [height, setHeight] = useState<number>();

  useLayoutEffect(() => {
    if (!element) return undefined;
    const measure = () => {
      const top = Math.max(0, element.getBoundingClientRect().top);
      const viewport = window.visualViewport?.height || window.innerHeight;
      setHeight(Math.max(0, Math.floor(viewport - top - bottomGap)));
    };
    measure();
    const observer = new ResizeObserver(measure);
    if (element.parentElement) observer.observe(element.parentElement);
    observer.observe(document.body);
    window.addEventListener('resize', measure);
    window.visualViewport?.addEventListener('resize', measure);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
      window.visualViewport?.removeEventListener('resize', measure);
    };
  }, [element, bottomGap]);

  return { ref, height };
}
